import { Modal } from 'antd';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import handlePlural from '../../../util/handlePlural';
import MobileDrawerHeader from '../../UI/MobileDrawerHeader';
import Scroller from '../../UI/Scroller/Scroller';
import TitlesDataStore from '../containers/TitlesDataStore';
import TitleExportExcel from './TitleExportExcel';
import TitleExportPowerpoint from './TitleExportPowerpoint';
import PropTypes from 'prop-types';

export class TitleExport extends React.Component {
	static propTypes = {
		skus: PropTypes.array,
	};

	constructor(props) {
		super(props);

		this.state = {
			aspect: [],
			visible: false,
		};
	}

	render() {
		return (
			<div>
				<div onClick={this.showModal}>{this.props.children}</div>
				<Modal
					width={700}
					visible={this.state.visible}
					title={this.getModalTitle()}
					onCancel={() => this.handleCancel()}
					footer={null}>
					{this.renderExportInterface()}
				</Modal>
			</div>
		);
	}

	getModalTitle = () => {
		const { skus } = this.props;
		return (
			<div
				style={{
					fontSize: '18px',
					fontWeight: 'bold',
					marginBottom: '10px',
				}}>
				Export Information for {handlePlural('title', skus.length)}
			</div>
		);
	};

	showModal = () => {
		this.setState({
			visible: true,
		});
	};

	handleCancel = () => {
		this.setState({ visible: false });
	};

	renderExportInterface = () => {
		const { skus } = this.props;
		var { visible, aspect } = this.state;
		return (
			<React.Fragment>
				{visible && (
					<React.Fragment>
						<MobileDrawerHeader header="Export" />
						<div
							style={{
								backgroundColor: '#ffffff',
							}}>
							<div style={{ marginBottom: '10px' }}>
								<TitlesDataStore skus={skus}>
									{titleDataStore =>
										!titleDataStore.state.isLoading && (
											<React.Fragment>
												<div
													style={{
														borderBottom:
															'1px solid #d2d6d8',
														marginBottom: '5px',
														paddingBottom: '5px',
													}}>
													<Scroller>
														{this.renderJacketSection(
															titleDataStore,
														)}
													</Scroller>
												</div>
												<div
													style={{
														fontSize: '15px',
														fontWeight: 'bold',
														marginBottom: '5px',
													}}>
													Export To:
												</div>
												<div>
													<div className="column">
														<TitleExportPowerpoint
															aspect={aspect}
														/>
													</div>
													<div className="column-spaced">
														<TitleExportExcel
															aspect={aspect}
														/>
													</div>
													<div className="clear" />
												</div>
											</React.Fragment>
										)
									}
								</TitlesDataStore>
							</div>
						</div>
					</React.Fragment>
				)}
			</React.Fragment>
		);
	};

	renderJacketSection = titleDataStore => {
		return (
			titleDataStore.state.titles &&
			titleDataStore.state.titles.length > 0 &&
			titleDataStore.state.titles.map(this.renderJacket)
		);
	};

	renderJacket = title => {
		const uri =
			title &&
			title.images &&
			title.images.filter(im => im.type === 'jacketCover').length > 0 &&
			title.images.filter(im => im.type === 'jacketCover')[0].uri;

		return (
			<div
				key={title.sku}
				className="relative"
				style={{ marginLeft: '5px' }}>
				<div>
					<img
						alt={title.name}
						id={title.sku}
						height="90"
						onLoad={this.onImgLoad}
						src={uri}
					/>
				</div>
			</div>
		);
	};

	onImgLoad = ({ target: img }) => {
		var { aspect } = this.state;
		aspect.push({
			sku: img.id,
			ratio: img.offsetWidth / img.offsetHeight,
		});
		this.setState({ aspect });
	};
}

export default withIsMobile(TitleExport);
